/* Earth Revibe — global chrome behavior (vanilla port of the Next.js storefront) */
(function () {
  'use strict';

  var ER = (window.ER = window.ER || {});

  /* ---------- scroll lock ---------- */
  ER.lock = function () {
    document.documentElement.classList.add('er-lock');
  };
  ER.unlock = function () {
    document.documentElement.classList.remove('er-lock');
  };

  /* ---------- Lenis smooth scroll — desktop + fine pointer only ---------- */
  function initLenis() {
    if (typeof window.Lenis !== 'function') return;
    var mq = window.matchMedia('(pointer: fine) and (min-width: 1024px)');
    var lenis = null;
    var rafId = null;

    function raf(time) {
      if (lenis) {
        lenis.raf(time);
        rafId = requestAnimationFrame(raf);
      }
    }
    function enable() {
      if (lenis) return;
      lenis = new window.Lenis({
        lerp: 0.04,
        duration: 1.6,
        smoothWheel: true,
        wheelMultiplier: 0.8,
        autoResize: true,
      });
      rafId = requestAnimationFrame(raf);
    }
    function disable() {
      if (!lenis) return;
      lenis.destroy();
      lenis = null;
      if (rafId) cancelAnimationFrame(rafId);
    }
    function sync(m) {
      if (m.matches) enable();
      else disable();
    }
    sync(mq);
    mq.addEventListener('change', sync);
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'auto';
    }
  }

  /* ---------- header: scrolled + transparent-over-hero ---------- */
  function initHeader() {
    var header = document.querySelector('.er-header');
    if (!header) return;
    var isHome = document.body.classList.contains('template-index');

    function update() {
      var scrolled = window.scrollY > 10;
      header.classList.toggle('is-scrolled', scrolled);
      if (isHome) {
        var covers = document.getElementById('home-covers');
        var pastCovers = true;
        if (covers) pastCovers = covers.getBoundingClientRect().bottom <= 64;
        header.classList.toggle('is-transparent', !pastCovers);
      }
    }
    update();
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
  }

  /* ---------- announcement bar ---------- */
  var ANNOUNCE_KEY = 'er:announcement-dismissed';
  function initAnnouncement() {
    var bar = document.querySelector('.er-announcement');
    if (!bar) return;
    if (localStorage.getItem(ANNOUNCE_KEY) === '1') {
      bar.remove();
      return;
    }
    var msgs = [];
    try {
      msgs = JSON.parse(bar.getAttribute('data-messages') || '[]');
    } catch (e) {
      msgs = [];
    }
    var el = bar.querySelector('.er-announcement__msg');
    if (!el || msgs.length < 2) return;
    var idx = 0;
    setInterval(function () {
      el.classList.add('is-hidden');
      setTimeout(function () {
        idx = (idx + 1) % msgs.length;
        el.textContent = msgs[idx];
        el.classList.remove('is-hidden');
      }, 300);
    }, 4000);
  }

  /* ---------- drawers ---------- */
  function openDrawer(root) {
    if (!root) return;
    root.hidden = false;
    ER.lock();
  }
  function closeDrawer(root) {
    if (!root) return;
    root.hidden = true;
    ER.unlock();
  }

  ER.openCart = function () {
    openDrawer(document.getElementById('er-cart'));
  };
  ER.closeCart = function () {
    closeDrawer(document.getElementById('er-cart'));
  };

  /* ---------- cart engine (Shopify AJAX + Section Rendering) ---------- */
  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count > 99 ? '99+' : String(count);
      el.setAttribute('data-count', String(count));
    });
  }

  function swapCartSection(html) {
    var wrapper = document.getElementById('shopify-section-cart-drawer');
    if (!wrapper || !html) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.getElementById('shopify-section-cart-drawer');
    var wasOpen = !document.getElementById('er-cart').hidden;
    if (fresh) wrapper.innerHTML = fresh.innerHTML;
    if (wasOpen) {
      var root = document.getElementById('er-cart');
      if (root) root.hidden = false;
    }
    applyStashedDiscount();
  }

  ER.refreshCart = function () {
    fetch('/?sections=cart-drawer')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        swapCartSection(data['cart-drawer']);
        return fetch('/cart.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        if (cart) updateCartCount(cart.item_count);
      })
      .catch(function () {});
  };

  function cartChange(line, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        line: line,
        quantity: quantity,
        sections: 'cart-drawer',
        sections_url: '/',
      }),
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateCartCount(cart.item_count);
        if (cart.sections) swapCartSection(cart.sections['cart-drawer']);
      })
      .catch(function () {});
  }

  ER.addToCart = function (id, quantity, properties) {
    var payload = {
      items: [{ id: Number(id), quantity: quantity || 1 }],
      sections: 'cart-drawer',
      sections_url: '/',
    };
    if (properties) payload.items[0].properties = properties;
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (e) { throw e; });
        return r.json();
      })
      .then(function (res) {
        if (res.sections) swapCartSection(res.sections['cart-drawer']);
        return fetch('/cart.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        if (cart) updateCartCount(cart.item_count);
        ER.openCart();
        return cart;
      });
  };

  /* ---------- discount code (applied at checkout via /discount/CODE) ---------- */
  var DISCOUNT_KEY = 'er:discount-code';
  function applyStashedDiscount() {
    var code = localStorage.getItem(DISCOUNT_KEY) || '';
    var field = document.querySelector('[data-discount-form]');
    var applied = document.querySelector('[data-discount-applied]');
    var label = document.querySelector('[data-discount-code-label]');
    var checkout = document.querySelector('[data-checkout-link]');
    if (applied && field) {
      applied.hidden = !code;
      field.hidden = !!code;
      if (label) label.textContent = code;
    }
    if (checkout) {
      checkout.setAttribute(
        'href',
        code ? '/discount/' + encodeURIComponent(code) + '?redirect=/checkout' : '/checkout'
      );
    }
  }

  function handleDiscountApply() {
    var input = document.querySelector('[data-discount-input]');
    if (!input) return;
    var code = (input.value || '').trim();
    if (!code) return;
    localStorage.setItem(DISCOUNT_KEY, code);
    fetch('/discount/' + encodeURIComponent(code)).then(function () { ER.refreshCart(); }).catch(function () {});
    applyStashedDiscount();
  }

  /* ---------- wishlist ----------
     Guest-first: the storefront's wishlist is server-backed behind auth, which
     Shopify has no equivalent for. Handles live in localStorage; the page
     rehydrates each one from /products/{handle}.js so prices/stock stay live. */
  var WISHLIST_KEY = 'er:wishlist';

  function getWishlist() {
    try {
      var raw = JSON.parse(localStorage.getItem(WISHLIST_KEY) || '[]');
      return Array.isArray(raw) ? raw.filter(function (h) { return typeof h === 'string'; }) : [];
    } catch (e) {
      return [];
    }
  }
  function setWishlist(list) {
    try {
      localStorage.setItem(WISHLIST_KEY, JSON.stringify(list));
    } catch (e) {}
    syncHearts(document);
    updateWishCount();
  }
  ER.wishlist = getWishlist;
  ER.toggleWishlist = function (handle) {
    if (!handle) return false;
    var list = getWishlist();
    var i = list.indexOf(handle);
    if (i === -1) list.push(handle);
    else list.splice(i, 1);
    setWishlist(list);
    return i === -1;
  };

  function syncHearts(scope) {
    var list = getWishlist();
    (scope || document).querySelectorAll('[data-wish-toggle]').forEach(function (btn) {
      var on = list.indexOf(btn.getAttribute('data-wish-toggle')) !== -1;
      btn.classList.toggle('is-active', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      btn.setAttribute('aria-label', on ? 'Remove from wishlist' : 'Add to wishlist');
    });
  }

  function updateWishCount() {
    var n = getWishlist().length;
    document.querySelectorAll('[data-wish-count]').forEach(function (el) {
      el.setAttribute('data-count', String(n));
      el.textContent = n > 9 ? '9+' : String(n);
    });
  }

  /* ---------- wishlist page ---------- */
  function initWishlistPage() {
    var root = document.querySelector('[data-wish-page]');
    if (!root) return;
    var grid = root.querySelector('[data-wish-grid]');
    var empty = root.querySelector('[data-wish-empty]');
    var head = root.querySelector('[data-wish-head]');
    var countEl = root.querySelector('[data-wish-total]');

    function render() {
      var handles = getWishlist();
      if (!handles.length) {
        grid.innerHTML = '';
        grid.hidden = true;
        head.hidden = true;
        empty.hidden = false;
        return;
      }
      empty.hidden = true;

      Promise.all(
        handles.map(function (h) {
          return fetch('/products/' + encodeURIComponent(h) + '.js')
            .then(function (r) { return r.ok ? r.json() : null; })
            .catch(function () { return null; });
        })
      ).then(function (products) {
        // Drop handles that 404 (product deleted/unpublished) so the list self-heals.
        var live = [];
        var alive = [];
        products.forEach(function (p, i) {
          if (p) { live.push(p); alive.push(handles[i]); }
        });
        if (alive.length !== handles.length) {
          try { localStorage.setItem(WISHLIST_KEY, JSON.stringify(alive)); } catch (e) {}
          updateWishCount();
        }
        if (!live.length) {
          grid.innerHTML = '';
          grid.hidden = true;
          head.hidden = true;
          empty.hidden = false;
          return;
        }
        head.hidden = false;
        grid.hidden = false;
        countEl.textContent = live.length + (live.length === 1 ? ' item' : ' items');
        grid.innerHTML = live.map(cardHtml).join('');
      });
    }

    function money(cents) {
      return 'Rs. ' + (cents / 100).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }
    function esc(s) {
      return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }
    function img(src, w) {
      if (!src) return '';
      return src.replace(/(\.[a-z]{3,4})(\?|$)/i, '_' + w + 'x$1$2');
    }

    function cardHtml(p) {
      var v = (p.variants || []).find(function (x) { return x.available; }) || (p.variants || [])[0] || {};
      var inStock = !!p.available;
      var compare = v.compare_at_price && v.compare_at_price > v.price ? v.compare_at_price : null;
      return (
        '<div class="er-wish__item">' +
          '<a class="er-wish__imgwrap" href="/products/' + esc(p.handle) + '">' +
            (p.featured_image
              ? '<img src="' + esc(img(p.featured_image, 400)) + '" alt="' + esc(p.title) + '" loading="lazy" width="300" height="400">'
              : '') +
            (inStock ? '' : '<span class="er-wish__oos"><span>SOLD OUT</span></span>') +
          '</a>' +
          '<a class="er-wish__name" href="/products/' + esc(p.handle) + '">' + esc(p.title) + '</a>' +
          '<div class="er-wish__price">' +
            '<span class="v">' + money(v.price || p.price) + '</span>' +
            (compare ? '<span class="c">' + money(compare) + '</span>' : '') +
          '</div>' +
          (inStock && v.id
            ? '<button type="button" class="er-wish__add" data-wish-add="' + v.id + '">ADD TO BAG</button>'
            : '<div class="er-wish__soldout"><span>SOLD OUT</span></div>') +
          '<button type="button" class="er-wish__remove" data-wish-remove="' + esc(p.handle) + '">Remove</button>' +
        '</div>'
      );
    }

    root.addEventListener('click', function (e) {
      var rm = e.target.closest('[data-wish-remove]');
      var add = e.target.closest('[data-wish-add]');
      if (rm) {
        ER.toggleWishlist(rm.getAttribute('data-wish-remove'));
        render();
      } else if (add) {
        add.disabled = true;
        ER.addToCart(add.getAttribute('data-wish-add'), 1)
          .then(function () { add.textContent = 'ADDED'; })
          .catch(function () { add.disabled = false; });
      }
    });

    render();
    window.addEventListener('storage', function (e) {
      if (e.key === WISHLIST_KEY) render();
    });
  }

  /* ---------- size guide ----------
     Rows carry inches in data-in; CM is derived (x2.54, 1dp) so the two units
     can't drift. Mirrors SizeGuideSheet in product-detail.tsx. */
  function setSizeGuideUnit(unit) {
    var sheet = document.querySelector('[data-sizeguide]');
    if (!sheet) return;
    sheet.querySelectorAll('[data-sizeguide-unit]').forEach(function (b) {
      var on = b.getAttribute('data-sizeguide-unit') === unit;
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    sheet.querySelectorAll('.val[data-in]').forEach(function (cell) {
      var inches = parseFloat(cell.getAttribute('data-in'));
      if (isNaN(inches)) return;
      cell.textContent = unit === 'CM' ? (inches * 2.54).toFixed(1) : String(inches);
    });
  }

  /* ---------- product card sliders (clone-looped scroll-snap) ---------- */
  function initCardSliders(scope) {
    (scope || document).querySelectorAll('[data-pcard-scroller]').forEach(function (el) {
      if (el.dataset.init) return;
      el.dataset.init = '1';
      var count = Number(el.getAttribute('data-count') || 0);
      if (count < 2) return;
      var card = el.closest('[data-pcard]');
      var dots = card ? card.querySelectorAll('[data-pcard-dots] span') : [];
      var offers = card ? card.querySelector('[data-pcard-offers]') : null;
      var badge = card ? card.querySelector('[data-pcard-badge]') : null;

      function setInitial() {
        var w = el.offsetWidth;
        if (!w) return requestAnimationFrame(setInitial);
        el.style.scrollBehavior = 'auto';
        el.scrollLeft = w;
        requestAnimationFrame(function () { el.style.scrollBehavior = ''; });
      }
      setInitial();

      function realIndex() {
        var w = el.offsetWidth;
        if (!w) return 0;
        var idx = Math.round(el.scrollLeft / w);
        if (idx === 0) return count - 1;
        if (idx === count + 1) return 0;
        return idx - 1;
      }

      el.addEventListener('scroll', function () {
        var real = realIndex();
        dots.forEach(function (d, i) { d.classList.toggle('is-active', i === real); });
        if (offers) offers.classList.toggle('is-visible', real === 1);
        if (badge) badge.style.opacity = real === 0 ? '1' : '0';
      }, { passive: true });

      function jumpIfOnClone() {
        var w = el.offsetWidth;
        if (!w) return;
        var idx = Math.round(el.scrollLeft / w);
        if (idx === 0 || idx === count + 1) {
          var target = idx === 0 ? count : 1;
          el.style.scrollBehavior = 'auto';
          el.scrollLeft = target * w;
          requestAnimationFrame(function () { el.style.scrollBehavior = ''; });
        }
      }
      if ('onscrollend' in window) {
        el.addEventListener('scrollend', jumpIfOnClone);
      } else {
        var t = null;
        el.addEventListener('scroll', function () {
          if (t) clearTimeout(t);
          t = setTimeout(jumpIfOnClone, 140);
        }, { passive: true });
      }
    });
  }

  /* ---------- PDP ---------- */
  function initPdp() {
    var root = document.querySelector('[data-er-pdp]');
    if (!root || root.dataset.init) return;
    root.dataset.init = '1';

    /* gallery: one swipe track with dots + "1 / n"; arrows only on desktop */
    var scroller = root.querySelector('[data-pdp-scroller]');
    var dots = root.querySelectorAll('[data-pdp-dots] span');
    var countEl = root.querySelector('[data-pdp-count]');
    var slideIdx = 0;
    if (scroller && dots.length > 1) {
      scroller.addEventListener('scroll', function () {
        var w = scroller.offsetWidth;
        if (!w) return;
        var idx = Math.round(scroller.scrollLeft / w);
        if (idx === slideIdx) return;
        slideIdx = idx;
        dots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
        if (countEl) countEl.textContent = (idx + 1) + ' / ' + dots.length;
      }, { passive: true });
      var goSlide = function (i) {
        if (i < 0 || i >= dots.length) return;
        scroller.scrollTo({ left: i * scroller.offsetWidth, behavior: 'smooth' });
      };
      var prev = root.querySelector('[data-pdp-prev]');
      var next = root.querySelector('[data-pdp-next]');
      if (prev) prev.addEventListener('click', function () { goSlide(slideIdx - 1); });
      if (next) next.addEventListener('click', function () { goSlide(slideIdx + 1); });
    }

    /* sizes: nothing is pre-selected (no silent default size in the bag),
       sold-out sizes open "notify me" instead of doing nothing */
    var selectedVariant = null;
    var sizeWrap = root.querySelector('[data-pdp-sizes]');
    var sizes = root.querySelectorAll('[data-pdp-variant]');
    var priceEl = root.querySelector('[data-pdp-price]');
    var offerPriceEl = root.querySelector('[data-pdp-offer-price]');
    var selEl = root.querySelector('[data-pdp-sel]');
    var sizeErr = root.querySelector('[data-pdp-sizeerr]');
    var low = root.querySelector('[data-pdp-lowstock]');
    var stickyChips = document.querySelectorAll('[data-sticky-variant]');

    function sizeLabel(btn) {
      var s = btn.querySelector('[data-size-label]');
      return s ? s.textContent.trim() : '';
    }
    function isSoldOut(btn) {
      return btn.getAttribute('data-soldout') === '1';
    }

    function syncLowStock(btn) {
      if (!low) return;
      var stock = Number(btn.getAttribute('data-stock') || 0);
      if (stock > 0 && stock <= 5) {
        var sizeName = sizeLabel(btn);
        low.hidden = false;
        low.querySelector('.msg').textContent = sizeName
          ? ('Only ' + stock + ' left in ' + sizeName + ' — order soon')
          : ('Only ' + stock + ' left — order soon');
      } else {
        low.hidden = true;
      }
    }

    function clearSizeError() {
      if (sizeWrap) sizeWrap.classList.remove('is-error');
      if (sizeErr) sizeErr.hidden = true;
    }
    function showSizeError() {
      if (!sizeWrap) return;
      sizeWrap.classList.remove('is-error');
      void sizeWrap.offsetWidth;
      sizeWrap.classList.add('is-error');
      if (sizeErr) sizeErr.hidden = false;
      var r = sizeWrap.getBoundingClientRect();
      if (r.top < 80 || r.bottom > window.innerHeight - 90) {
        window.scrollTo({ top: Math.max(0, window.pageYOffset + r.top - 200), behavior: 'smooth' });
      }
    }

    function selectSize(btn) {
      if (!btn || isSoldOut(btn)) return;
      sizes.forEach(function (b) {
        var on = b === btn;
        b.classList.toggle('is-selected', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      selectedVariant = btn.getAttribute('data-pdp-variant');
      if (priceEl && btn.getAttribute('data-price')) priceEl.textContent = btn.getAttribute('data-price');
      if (offerPriceEl && btn.getAttribute('data-offer')) offerPriceEl.textContent = btn.getAttribute('data-offer');
      if (selEl) selEl.textContent = '· ' + sizeLabel(btn);
      stickyChips.forEach(function (c) {
        c.classList.toggle('is-selected', c.getAttribute('data-sticky-variant') === selectedVariant);
      });
      clearSizeError();
      syncLowStock(btn);
    }
    function sizeBtnFor(id) {
      return root.querySelector('[data-pdp-variant="' + id + '"]');
    }

    sizes.forEach(function (btn) {
      if (btn.classList.contains('is-selected')) selectSize(btn);
      btn.addEventListener('click', function () {
        if (isSoldOut(btn)) { openNotify(btn); return; }
        selectSize(btn);
      });
    });
    stickyChips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        var btn = sizeBtnFor(chip.getAttribute('data-sticky-variant'));
        if (!btn) return;
        if (isSoldOut(btn)) { openNotify(btn); return; }
        selectSize(btn);
      });
    });

    var addBtn = root.querySelector('[data-pdp-add]');
    var buyBtn = root.querySelector('[data-pdp-buy]');
    function variantId() {
      if (sizes.length) return selectedVariant;
      return addBtn && addBtn.getAttribute('data-default-variant');
    }
    if (addBtn) {
      addBtn.addEventListener('click', function () {
        var id = variantId();
        if (!id) { showSizeError(); return; }
        addBtn.disabled = true;
        ER.addToCart(id, 1)
          .catch(function () {})
          .then(function () { addBtn.disabled = false; });
      });
    }
    if (buyBtn) {
      buyBtn.addEventListener('click', function () {
        var id = variantId();
        if (!id) { showSizeError(); return; }
        buyBtn.disabled = true;
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] }),
        })
          .then(function () { return fetch('/cart.js').then(function (r) { return r.json(); }); })
          .then(function (cart) {
            updateCartCount(cart.item_count);
            // Magic Checkout skips the theme's InitiateCheckout (theme.liquid only
            // fires it for .er-cart__checkout), so send it here with the live cart.
            if (window.fbq) {
              window.fbq('track', 'InitiateCheckout', {
                value: cart.total_price / 100,
                currency: cart.currency,
                content_ids: cart.items.map(function (i) { return String(i.product_id); }),
                num_items: cart.item_count,
              }, { eventID: 'ic_' + Date.now() + '_' + Math.random().toString(36).slice(2, 10) });
            }
            // Magic Checkout (Pro, magic-shopify.js) binds clicks on checkout
            // links, not navigations, so click a throwaway /checkout link. If
            // Magic hasn't loaded, the click just navigates to /checkout.
            var link = document.createElement('a');
            link.href = '/checkout';
            link.style.display = 'none';
            document.body.appendChild(link);
            link.click();
            setTimeout(function () { link.remove(); buyBtn.disabled = false; }, 1500);
          })
          .catch(function () { buyBtn.disabled = false; });
      });
    }

    var share = root.querySelector('[data-pdp-share]');
    if (share) {
      share.addEventListener('click', function () {
        var url = window.location.href;
        if (navigator.share) {
          navigator.share({ title: document.title, url: url }).catch(function () {});
        } else if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(url).catch(function () {});
        }
      });
    }

    /* offer box: one tap applies the code to the cart (same /discount/CODE
       route and localStorage stash the cart drawer uses) and copies it */
    var offer = root.querySelector('[data-pdp-offer]');
    if (offer) {
      var offerCode = offer.getAttribute('data-offer-code') || '';
      var offerCta = offer.querySelector('[data-offer-cta]');
      var markApplied = function () {
        offer.classList.add('is-applied');
        if (offerCta) offerCta.textContent = 'APPLIED ✓';
      };
      try {
        if (offerCode && localStorage.getItem(DISCOUNT_KEY) === offerCode) markApplied();
      } catch (e) {}
      offer.addEventListener('click', function () {
        if (!offerCode) return;
        try { localStorage.setItem(DISCOUNT_KEY, offerCode); } catch (e) {}
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(offerCode).catch(function () {});
        }
        fetch('/discount/' + encodeURIComponent(offerCode) + '?redirect=/cart.js', { credentials: 'same-origin' })
          .catch(function () {});
        applyStashedDiscount();
        markApplied();
      });
    }

    var pinBox = root.querySelector('[data-pdp-pincode]');
    if (pinBox) {
      var pinInput = pinBox.querySelector('[data-pincode-input]');
      var pinBtn = pinBox.querySelector('[data-pincode-check]');
      var pinResult = pinBox.querySelector('[data-pincode-result]');
      var pinBusy = false;
      var showPinResult = function (html, isError) {
        pinResult.hidden = false;
        pinResult.innerHTML = html;
        pinResult.classList.toggle('is-error', !!isError);
      };
      var genericEta = function () {
        var a = new Date(); a.setDate(a.getDate() + 3);
        var b = new Date(); b.setDate(b.getDate() + 5);
        var fmt = function (d) { return d.toLocaleDateString('en-IN', { day: 'numeric', month: 'short' }); };
        return fmt(a) + '–' + fmt(b);
      };
      var genericLine = function () {
        return 'Usually delivers by ' + genericEta() + ' &middot; COD available at checkout &middot; Free shipping';
      };
      var runPinCheck = function () {
        if (pinBusy) return;
        var val = (pinInput.value || '').replace(/\D/g, '');
        if (val.length !== 6) {
          showPinResult('Please enter a valid 6-digit pincode.', true);
          return;
        }
        pinBusy = true;
        pinBtn.disabled = true;
        showPinResult('Checking&hellip;', false);
        fetch('https://er-returns.sahilxyd00.workers.dev/api/pincode?pin=' + val)
          .then(function (r) { return r.json(); })
          .then(function (d) {
            if (d && d.ok && d.deliverable && d.etd) {
              var cod = d.cod
                ? 'COD available &middot; Free shipping'
                : 'COD not available at this pincode';
              showPinResult('Delivers by ' + d.etd + ' &middot; ' + cod, false);
            } else if (d && d.ok && d.deliverable === false) {
              showPinResult('Sorry, we currently don&rsquo;t deliver to this pincode.', true);
            } else {
              showPinResult(genericLine(), false);
            }
          })
          .catch(function () { showPinResult(genericLine(), false); })
          .then(function () { pinBusy = false; pinBtn.disabled = false; });
      };
      if (pinInput) {
        pinInput.addEventListener('input', function () {
          pinInput.value = pinInput.value.replace(/\D/g, '').slice(0, 6);
        });
        pinInput.addEventListener('keydown', function (e) {
          if (e.key === 'Enter') { e.preventDefault(); runPinCheck(); }
        });
      }
      if (pinBtn) pinBtn.addEventListener('click', runPinCheck);
    }

    /* bottom sheets: notify-me (sold-out size) + find-my-size */
    function openSheet(el) {
      if (!el) return;
      el.hidden = false;
      ER.lock();
    }
    function closeSheets() {
      var open = document.querySelectorAll('.er-pdp-sheet:not([hidden])');
      if (!open.length) return;
      open.forEach(function (s) { s.hidden = true; });
      ER.unlock();
    }
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-pdp-sheet-close]')) closeSheets();
    });
    window.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeSheets();
    });

    var NOTIFY_API = 'https://er-returns.sahilxyd00.workers.dev/api/notify-me';
    var notifySheet = document.querySelector('[data-pdp-notify]');
    var notifyFor = null;
    function openNotify(btn) {
      if (!notifySheet || !btn) return;
      notifyFor = btn;
      notifySheet.querySelectorAll('[data-notify-size]').forEach(function (s) { s.textContent = sizeLabel(btn); });
      notifySheet.querySelector('[data-notify-form]').hidden = false;
      notifySheet.querySelector('[data-notify-done]').hidden = true;
      notifySheet.querySelector('[data-notify-err]').hidden = true;
      var inp = notifySheet.querySelector('[data-notify-phone]');
      try {
        var saved = localStorage.getItem('er:notify-phone');
        if (saved && !inp.value) inp.value = saved;
      } catch (e) {}
      closeSheets();
      openSheet(notifySheet);
    }
    if (notifySheet) {
      var nInput = notifySheet.querySelector('[data-notify-phone]');
      var nGo = notifySheet.querySelector('[data-notify-go]');
      var nErr = notifySheet.querySelector('[data-notify-err]');
      var nFail = function (msg) {
        nErr.textContent = msg;
        nErr.hidden = false;
      };
      nInput.addEventListener('input', function () {
        nInput.value = nInput.value.replace(/\D/g, '').slice(-10);
      });
      nGo.addEventListener('click', function () {
        var phone = nInput.value.replace(/\D/g, '').slice(-10);
        if (!/^[6-9]\d{9}$/.test(phone)) { nFail('Please enter a valid 10-digit mobile number.'); return; }
        if (!notifyFor) return;
        nErr.hidden = true;
        nGo.disabled = true;
        nGo.textContent = 'SAVING…';
        fetch(NOTIFY_API, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            variant_id: notifyFor.getAttribute('data-pdp-variant'),
            product_handle: root.getAttribute('data-handle'),
            size: sizeLabel(notifyFor),
            phone: phone,
          }),
        })
          .then(function (r) { return r.json(); })
          .then(function (d) {
            if (d && d.ok) {
              try { localStorage.setItem('er:notify-phone', phone); } catch (e) {}
              notifySheet.querySelector('[data-notify-num]').textContent = '+91 ' + phone;
              notifySheet.querySelector('[data-notify-form]').hidden = true;
              notifySheet.querySelector('[data-notify-done]').hidden = false;
            } else if (d && d.reason === 'in_stock') {
              nFail('Good news: this size is back in stock. Refresh the page to order it.');
            } else {
              nFail('Could not save that. Please try again.');
            }
          })
          .catch(function () { nFail('Network issue. Please try again.'); })
          .then(function () {
            nGo.disabled = false;
            nGo.textContent = 'NOTIFY ME ON WHATSAPP';
          });
      });
    }

    /* find my size: height + weight -> a size from THIS product's chart.
       Only offered when the chart covers every size on sale and its
       chest/waist numbers rise size by size (a broken chart hides it). */
    var fsSheet = document.querySelector('[data-pdp-fs]');
    var fsLink = root.querySelector('[data-fs-link]');
    var chartEl = document.querySelector('[data-pdp-chart]');
    var fsChart = null;
    function normSize(s) {
      s = String(s || '').trim().toUpperCase().replace(/\s+/g, '');
      if (s === '2XL') return 'XXL';
      if (s === '3XL') return 'XXXL';
      return s;
    }
    function parseChart(raw) {
      var lines = String(raw || '').split(/\r?\n/).map(function (l) { return l.trim(); }).filter(Boolean);
      if (lines.length < 3) return null;
      var head = lines[0].split(',').map(function (h) { return h.trim().toLowerCase(); });
      var col = function (word) {
        for (var i = 1; i < head.length; i++) if (head[i].indexOf(word) > -1) return i;
        return -1;
      };
      var key = col('chest') > -1 ? 'chest' : (col('waist') > -1 ? 'waist' : null);
      if (!key) return null;
      var ci = col(key), li = col('length');
      var rows = [];
      for (var r = 1; r < lines.length; r++) {
        var c = lines[r].split(',');
        var v = parseFloat(c[ci]);
        if (!c[0] || isNaN(v)) return null;
        rows.push({ size: normSize(c[0]), m: v, len: li > -1 ? parseFloat(c[li]) : NaN });
      }
      return { key: key, rows: rows };
    }
    if (chartEl && fsSheet && sizes.length > 1) {
      try { fsChart = parseChart(JSON.parse(chartEl.textContent || '""')); } catch (e) { fsChart = null; }
      if (fsChart) {
        // keep only chart rows that are real sizes on this product, in chart order
        var onSale = {};
        sizes.forEach(function (b) { onSale[normSize(sizeLabel(b))] = b; });
        var covered = Object.keys(onSale).every(function (s) {
          return fsChart.rows.some(function (r) { return r.size === s; });
        });
        fsChart.rows = fsChart.rows.filter(function (r) { return onSale[r.size]; });
        var rising = fsChart.rows.every(function (r, i, a) { return !i || r.m >= a[i - 1].m; });
        if (!covered || !rising || fsChart.rows.length < 2) fsChart = null;
        else fsChart.btns = onSale;
      }
    }
    if (fsChart && fsLink) fsLink.hidden = false;

    function fsRecommend(hIn, kg) {
      var m = hIn * 0.0254;
      var bmi = kg / (m * m);
      var rows = fsChart.rows;
      var pick = -1, i, snug = false;
      if (fsChart.key === 'chest') {
        var need = (0.53 * kg + 0.3048 * hIn + 40) / 2.54 + 3.5;  // est. body chest (cm from kg + height) + ease, inches
        for (i = 0; i < rows.length; i++) if (rows[i].m >= need) { pick = i; break; }
        if (pick < 0) { pick = rows.length - 1; snug = true; }
        // Too short for this height? Go one up, but only when the chest is already
        // close or the next size barely changes it (boxy cuts are short on purpose).
        var minLen = 26 + (hIn - 69) * 0.6;          // 5'9" sits right at ~26" length
        if (!snug && !isNaN(rows[pick].len) && rows[pick].len < minLen && pick < rows.length - 1 &&
            (rows[pick].m - need < 2 || rows[pick + 1].m - rows[pick].m <= 1)) pick++;
      } else {
        var waist = (2.3 * bmi + 25) / 2.54;         // est. body waist, inches
        for (i = 0; i < rows.length; i++) if (rows[i].m >= waist - 0.5) { pick = i; break; }
        if (pick < 0) { pick = rows.length - 1; snug = true; }
      }
      return { row: rows[pick], snug: snug };
    }

    if (fsSheet && fsChart) {
      var fsH = fsSheet.querySelector('[data-fs-height]');
      var fsW = fsSheet.querySelector('[data-fs-weight]');
      var fsRes = fsSheet.querySelector('[data-fs-res]');
      var fsGo = fsSheet.querySelector('[data-fs-go]');
      var fsBtn = null;
      var fsRun = function () {
        var h = parseInt(fsH.value, 10), w = parseFloat(fsW.value);
        fsBtn = null;
        if (!h || !(w >= 35 && w <= 160)) {
          fsRes.hidden = true;
          fsGo.disabled = true;
          fsGo.textContent = 'ENTER HEIGHT AND WEIGHT';
          return;
        }
        try { localStorage.setItem('er:fs', JSON.stringify({ h: h, w: w })); } catch (e) {}
        var res = fsRecommend(h, w);
        fsBtn = fsChart.btns[res.row.size];
        var label = sizeLabel(fsBtn);
        fsSheet.querySelector('[data-fs-size]').textContent = label;
        fsSheet.querySelector('[data-fs-line]').textContent = 'Your size in this piece is ' + label;
        fsSheet.querySelector('[data-fs-sub]').textContent = res.snug
          ? 'This is our biggest size here, it may feel snug.'
          : (isSoldOut(fsBtn) ? label + ' is sold out right now.' : 'Want it roomier? Go one size up.');
        fsRes.hidden = false;
        fsGo.disabled = false;
        fsGo.textContent = isSoldOut(fsBtn) ? 'NOTIFY ME WHEN ' + label + ' IS BACK' : 'SELECT ' + label;
      };
      fsH.addEventListener('change', fsRun);
      fsW.addEventListener('input', fsRun);
      fsGo.addEventListener('click', function () {
        if (!fsBtn) return;
        if (isSoldOut(fsBtn)) { openNotify(fsBtn); return; }
        selectSize(fsBtn);
        closeSheets();
      });
      document.addEventListener('click', function (e) {
        if (!e.target.closest('[data-fs-open]')) return;
        try {
          var last = JSON.parse(localStorage.getItem('er:fs') || 'null');
          if (last && !fsH.value) { fsH.value = String(last.h); fsW.value = String(last.w); }
        } catch (err) {}
        fsRun();
        openSheet(fsSheet);
      });
    }
  }

  /* ---------- clicks (delegated) ---------- */
  document.addEventListener('click', function (e) {
    var t = function (sel) { return e.target.closest(sel); };

    if (t('[data-sizeguide-open]')) {
      e.preventDefault();
      var sg = document.querySelector('[data-sizeguide]');
      if (sg) {
        sg.hidden = false;
        ER.lock();
      }
    } else if (t('[data-sizeguide-close]')) {
      var sgc = document.querySelector('[data-sizeguide]');
      if (sgc) {
        sgc.hidden = true;
        ER.unlock();
      }
    } else if (t('[data-sizeguide-unit]')) {
      setSizeGuideUnit(t('[data-sizeguide-unit]').getAttribute('data-sizeguide-unit'));
    } else if (t('[data-wish-toggle]')) {
      // Cards are wrapped in product links — don't navigate on a heart tap.
      e.preventDefault();
      e.stopPropagation();
      var heart = t('[data-wish-toggle]');
      var added = ER.toggleWishlist(heart.getAttribute('data-wish-toggle'));
      if (added) {
        heart.classList.remove('er-pcard__heart--bounce');
        void heart.offsetWidth;
        heart.classList.add('er-pcard__heart--bounce');
      }
    } else if (t('[data-menu-open]')) {
      openDrawer(document.getElementById('er-menu'));
    } else if (t('[data-menu-close]')) {
      closeDrawer(document.getElementById('er-menu'));
    } else if (t('[data-cart-open]')) {
      e.preventDefault();
      ER.openCart();
    } else if (t('[data-cart-close]')) {
      ER.closeCart();
    } else if (t('[data-back]')) {
      window.history.back();
    } else if (t('[data-announcement-close]')) {
      localStorage.setItem(ANNOUNCE_KEY, '1');
      var bar = document.querySelector('.er-announcement');
      if (bar) bar.remove();
    } else if (t('[data-discount-apply]')) {
      handleDiscountApply();
    } else if (t('[data-discount-remove]')) {
      localStorage.removeItem(DISCOUNT_KEY); fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: '{"discount":""}' }).then(function () { ER.refreshCart(); }).catch(function () {});
      applyStashedDiscount();
    } else if (t('[data-cart-plus]')) {
      var el = t('[data-cart-plus]');
      var reload1 = !!el.closest('[data-cart-reload]');
      cartChange(Number(el.getAttribute('data-line')), Number(el.getAttribute('data-qty')) + 1).then(function () {
        if (reload1) window.location.reload();
      });
    } else if (t('[data-cart-minus]')) {
      var el2 = t('[data-cart-minus]');
      var q = Number(el2.getAttribute('data-qty'));
      var reload2 = !!el2.closest('[data-cart-reload]');
      if (q > 1)
        cartChange(Number(el2.getAttribute('data-line')), q - 1).then(function () {
          if (reload2) window.location.reload();
        });
    } else if (t('[data-cart-remove]')) {
      var el3 = t('[data-cart-remove]');
      var reload3 = !!el3.closest('[data-cart-reload]');
      cartChange(Number(el3.getAttribute('data-line')), 0).then(function () {
        if (reload3) window.location.reload();
      });
    } else if (t('[data-quickadd-open]')) {
      var card = t('[data-quickadd-open]').closest('[data-pcard]');
      var sheet = card && card.querySelector('[data-quickadd]');
      if (sheet) {
        sheet.hidden = false;
        ER.lock();
      }
    } else if (t('[data-quickadd-close]')) {
      var qa = t('[data-quickadd-close]').closest('[data-quickadd]');
      if (qa) {
        qa.hidden = true;
        ER.unlock();
      }
    } else if (t('[data-quickadd-variant]')) {
      var vbtn = t('[data-quickadd-variant]');
      var qa2 = vbtn.closest('[data-quickadd]');
      qa2.querySelectorAll('[data-quickadd-variant]').forEach(function (b) {
        b.classList.remove('is-selected');
      });
      vbtn.classList.add('is-selected');
      var confirm = qa2.querySelector('[data-quickadd-confirm]');
      if (confirm) confirm.disabled = false;
    } else if (t('[data-quickadd-confirm]')) {
      var cbtn = t('[data-quickadd-confirm]');
      var qa3 = cbtn.closest('[data-quickadd]');
      var sel = qa3.querySelector('[data-quickadd-variant].is-selected');
      if (sel) {
        cbtn.disabled = true;
        ER.addToCart(sel.getAttribute('data-quickadd-variant'), 1)
          .catch(function () {})
          .then(function () {
            qa3.hidden = true;
            cbtn.disabled = false;
          });
      }
    }

    // close drawers on backdrop click
    if (e.target.matches('[data-drawer-backdrop]')) {
      closeDrawer(e.target.closest('.er-drawer-root'));
      ER.unlock();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    if (e.target && e.target.matches && e.target.matches('[data-discount-input]')) {
      e.preventDefault();
      handleDiscountApply();
    }
  });

  window.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      var cart = document.getElementById('er-cart');
      var menu = document.getElementById('er-menu');
      if (cart && !cart.hidden) closeDrawer(cart);
      if (menu && !menu.hidden) closeDrawer(menu);
      var sg = document.querySelector('[data-sizeguide]');
      if (sg && !sg.hidden) {
        sg.hidden = true;
        ER.unlock();
      }
    }
  });

  /* ---------- boot ---------- */
  function boot() {
    initLenis();
    initHeader();
    initAnnouncement();
    applyStashedDiscount();
    initCardSliders(document);
    initPdp();
    syncHearts(document);
    updateWishCount();
    initWishlistPage();
    setSizeGuideUnit('IN'); // storefront default (IN — Abhishek, 14 Sep 2026)
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Theme editor: re-run announcement/header wiring when sections reload
  document.addEventListener('shopify:section:load', function () {
    initHeader();
    initAnnouncement();
    applyStashedDiscount();
    syncHearts(document);
    updateWishCount();
    initWishlistPage();
  });
})(); /* footer-only discount refresh: no item image re-render on coupon apply/remove */ (function(){if(!window.ER||!ER.refreshCart)return;var fullRefresh=ER.refreshCart;function syncDiscountUI(){var code=localStorage.getItem('er:discount-code')||'',field=document.querySelector('[data-discount-form]'),applied=document.querySelector('[data-discount-applied]'),label=document.querySelector('[data-discount-code-label]'),checkout=document.querySelector('[data-checkout-link]');if(applied&&field){applied.hidden=!code;field.hidden=!!code;if(label)label.textContent=code}if(checkout)checkout.setAttribute('href',code?'/discount/'+encodeURIComponent(code)+'?redirect=/checkout':'/checkout')}ER.refreshCart=function(){var live=document.querySelector('#shopify-section-cart-drawer .er-cart__foot');if(!live)return fullRefresh();fetch('/?sections=cart-drawer').then(function(r){return r.json()}).then(function(data){var doc=new DOMParser().parseFromString(data['cart-drawer']||'','text/html');var freshFoot=doc.querySelector('.er-cart__foot');var cur=document.querySelector('#shopify-section-cart-drawer .er-cart__foot');if(freshFoot&&cur){cur.innerHTML=freshFoot.innerHTML;syncDiscountUI()}else{fullRefresh()}}).catch(function(){})}})();

/* cart drawer: "Save this bag on WhatsApp" -> er-returns /api/cart-capture, picked up by er_abandoned.py for the cart ladder (27 Oct 2026). One line; the number field opens on tap. */
(function () {
  var API = 'https://er-returns.sahilxyd00.workers.dev/api/cart-capture';
  var PHONE_KEY = 'er:cart-phone', SIG_KEY = 'er:cartcap-sig';
  var opened = false;
  function get(k) { try { return localStorage.getItem(k) || ''; } catch (e) { return ''; } }
  function set(k, v) { try { if (v) localStorage.setItem(k, v); else localStorage.removeItem(k); } catch (e) {} }
  function box() { return document.querySelector('#shopify-section-cart-drawer [data-cartcap]'); }
  function cartItems() {
    return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
      return (c.items || []).map(function (i) { return { variant_id: i.variant_id, quantity: i.quantity }; }).slice(0, 30);
    });
  }
  function sig(items) { return items.map(function (i) { return i.variant_id + ':' + i.quantity; }).sort().join(','); }
  function save(phone, items) {
    return fetch(API, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ phone: phone, items: items }),
    }).then(function (r) { return r.json(); }).then(function (d) {
      if (!d || !d.ok) throw new Error((d && d.reason) || 'failed');
      set(PHONE_KEY, phone);
      set(SIG_KEY, sig(items));
    });
  }
  function paint() {
    var b = box();
    if (!b) return;
    var phone = get(PHONE_KEY);
    b.querySelector('[data-cartcap-open]').hidden = !!phone || opened;
    b.querySelector('[data-cartcap-form]').hidden = !!phone || !opened;
    b.querySelector('[data-cartcap-done]').hidden = !phone;
    var num = b.querySelector('[data-cartcap-num]');
    if (phone && num.textContent !== '+91 ' + phone) num.textContent = '+91 ' + phone;
    var inp = b.querySelector('[data-cartcap-phone]');
    if (!phone && inp && !inp.value) inp.value = get('er:notify-phone');
  }
  // keep the saved bag current when items change after the number was given
  var syncTimer = null;
  function sync() {
    clearTimeout(syncTimer);
    syncTimer = setTimeout(function () {
      var phone = get(PHONE_KEY);
      if (!phone || !box()) return;
      cartItems().then(function (items) {
        if (items.length && sig(items) !== get(SIG_KEY)) return save(phone, items);
      }).catch(function () {});
    }, 1500);
  }
  function fail(b, msg) {
    var err = b.querySelector('[data-cartcap-err]');
    err.textContent = msg;
    err.hidden = false;
  }
  function submit(b) {
    var btn = b.querySelector('[data-cartcap-go]');
    var inp = b.querySelector('[data-cartcap-phone]');
    var phone = inp.value.replace(/\D/g, '').slice(-10);
    if (!/^[6-9]\d{9}$/.test(phone)) { fail(b, 'Please enter a valid 10-digit mobile number.'); return; }
    b.querySelector('[data-cartcap-err]').hidden = true;
    btn.disabled = true;
    btn.textContent = 'SAVING…';
    cartItems()
      .then(function (items) { if (!items.length) throw new Error('empty'); return save(phone, items); })
      .then(function () { opened = false; paint(); })
      .catch(function () {
        btn.disabled = false;
        btn.textContent = 'SAVE';
        fail(b, 'Could not save that. Please try again.');
      });
  }
  function openForm(b, value) {
    opened = true;
    paint();
    var inp = b.querySelector('[data-cartcap-phone]');
    if (value) inp.value = value;
    inp.focus();
  }
  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var op = e.target.closest('[data-cartcap-open]');
    if (op) { openForm(op.closest('[data-cartcap]')); return; }
    var go = e.target.closest('[data-cartcap-go]');
    if (go) { submit(go.closest('[data-cartcap]')); return; }
    var ch = e.target.closest('[data-cartcap-change]');
    if (ch) {
      var old = get(PHONE_KEY);
      set(PHONE_KEY, '');
      set(SIG_KEY, '');
      openForm(ch.closest('[data-cartcap]'), old);
    }
  });
  document.addEventListener('input', function (e) {
    if (e.target.matches && e.target.matches('[data-cartcap-phone]')) e.target.value = e.target.value.replace(/\D/g, '').slice(-10);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && e.target.matches && e.target.matches('[data-cartcap-phone]')) {
      e.preventDefault();
      submit(e.target.closest('[data-cartcap]'));
    }
  });
  function init() {
    paint();
    sync();
    var wrap = document.getElementById('shopify-section-cart-drawer');
    // full drawer re-renders (add/change/remove) replace the wrapper's children
    if (wrap && window.MutationObserver) new MutationObserver(function () { paint(); sync(); }).observe(wrap, { childList: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
